// extracted by mini-css-extract-plugin
export var fullGrid = "_3b-3";
export var pdpPreviewContainer = "_3b-1";
export var previewContainer = "_3b-0";
export var togglePreviewContainer = "_3b-2";